    /* slider video popup */
    function createSlickVideo() {
        $('#videoPopupSlider').slick({
            vertical: true,
            verticalSwiping: true,
            infinite: false,
            speed: 300,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: $('#prevVideo'),
            nextArrow: $('#nextVideo'),
            adaptiveHeight: true,
            // centerMode: true,
            // centerPadding: '100px',
        });

        $('#videoPopupSlider').on('afterChange', function(event, slick, currentSlide){
            const slides = slick.$slides;
            slides.each((index, slide) => {
                const video = slide.querySelector('video');
                if (video) {
                    video.pause();
                    video.currentTime = 0;
                    if (index === currentSlide) {
                        setTimeout(() => {
                            video.play();
                            video.muted = false;
                        }, "500");
                    }
                }
            });

            const videoId = $(slides.get(currentSlide)).find('.popupBox').data('video-id');
            // AJAX untuk hit views
            if (videoId) {
                $.ajax({
                    url: BASE_URL + '/video-hit',
                    type: 'POST',
                    data: {
                        video_id: videoId,
                    },
                    success: function(response) {
                        // console.log('Hit view added for video:', videoId);
                    },
                    error: function() {
                        // console.error('Failed to add hit view');
                    }
                });
            }
        });
    }
    
    let isVideoSliderInitialized = false;
    window.triggerPopup = (el, index = 0) => {
        let target = document.querySelector(el);
        target.classList.add('active');

        // CASE 2: Video slider popup
        if (target.classList.contains('-popVideo')) {
            // Initialize slick only once
            if (!isVideoSliderInitialized) {
                createSlickVideo();
                isVideoSliderInitialized = true;
            } else {
                $('#videoPopupSlider').slick('setPosition');
            }
            $('#videoPopupSlider').slick('slickGoTo', index, true);

                // setTimeout(() => {
                //     const slides = document.querySelectorAll('#videoPopupSlider .popupBox');
                //     slides.forEach((slide, i) => {
                //         const video = slide.querySelector('video');
                //         if (video) {
                //             video.pause();
                //             video.currentTime = 0;
                //             if (index === i) {
                //                 video.play();
                //             }
                //         }
                //     });
                // }, "1000");
        }
    }

    window.closePopup = (el) => {
        let pop = document.querySelectorAll(".popup")
        const videos = document.querySelectorAll(".popup video");
        videos.forEach(video => {
            video.pause();
            video.muted = true;
            video.currentTime = 0;
        });
        if (!!el) {
            let dpop = document.querySelector(el)
            dpop.classList.remove('active');
        } else {
            pop.forEach(popup => {
                popup.classList.remove('active');
            });
        }
    }

    function isMobile() {
        return window.innerWidth <= 768;
    }
    
function setupVideos() {
    document.querySelectorAll('.-videoWrap').forEach(wrapper => {
        const video = wrapper.querySelector('.popvid');
        const playIcon = wrapper.querySelector('.playIcon');

        if (isMobile()) {
            video.removeAttribute('controls');
            video.setAttribute('loop', true);

            video.setAttribute('playsinline', '');
            video.setAttribute('muted', '');

            video.addEventListener('click', () => {
                if (video.paused) {
                    const playPromise = video.play();
                    if (playPromise !== undefined) {
                        playPromise
                            .then(() => {
                                video.muted = false;
                                playIcon.style.display = 'none';
                            })
                            .catch(err => {
                                console.warn('iOS blocked unmuted playback:', err);
                                video.muted = true;
                                video.play().then(() => {
                                    playIcon.style.display = 'none';
                                });
                            });
                    }
                } else {
                    video.pause();
                    playIcon.style.display = 'block';
                }
            });

            video.addEventListener('play', () => {
                playIcon.style.display = 'none';
            });

            video.addEventListener('pause', () => {
                playIcon.style.display = 'block';
            });

        } else {
            video.setAttribute('controls', true);
            video.removeAttribute('loop');
        }
    });
}

    
    window.addEventListener('DOMContentLoaded', setupVideos);
    window.addEventListener('resize', setupVideos);
    

    window.addEventListener('DOMContentLoaded', () => {
        // Open left-side content panel
        document.addEventListener('click', function(event) {
            const openBtn = event.target.closest('.popVideoProductOpen');
            if (openBtn) {
                const target = openBtn.closest('.popupVideoWrap').querySelector(
                    '.popVidContentTopItem.-left');
                if (target) target.classList.add('active');
            }
        });

        // Close left-side content panel
        document.addEventListener('click', function(event) {
            const closeBtn = event.target.closest('.popVideoProductClose');
            if (closeBtn) {
                const target = closeBtn.closest('.popupVideoWrap').querySelector(
                    '.popVidContentTopItem.-left');
                if (target) target.classList.remove('active');
            }
        });

        // Open review
        document.addEventListener('click', function(event) {
            const reviewBtn = event.target.closest('.popVidReview');
            if (reviewBtn) {
                const reviewPanel = reviewBtn.closest('.popupVideoWrap').querySelector('.popReview');
                if (reviewPanel) reviewPanel.style.bottom = '0';
            }
        });

        // Close review
        document.addEventListener('click', function(event) {
            const closeReview = event.target.closest('.closeReview');
            if (closeReview) {
                const reviewPanel = closeReview.closest('.popupVideoWrap').querySelector('.popReview');
                if (reviewPanel) reviewPanel.style.bottom = '-100%';
            }
        });
    });